<template>
  <div class="box">
    <div class="title">
      <i v-if="currentWhole" class="checkMark" @click="updateWhole"></i>
      <i v-else class="fork" @click="updateWhole"></i>
      <span class="header_title">Please select tourists that need a refund</span>
    </div>
    <ul>
      <li
        v-for="item in orderDetails.itemList"
        :key="item.itemId"
        @click="clickSwitch(item)"
        v-watermark="{ text: item.cerType }"
      >
        <i v-if="item.switchState" class="checkMark"></i>
        <i v-else class="fork"></i>
        <ul class="content">
          <template v-if="item.attrList[0].cerNo">
            <li v-for="item1 in item.attrList" :key="item1.id">
              <div class="item">
                <span>Name</span>
                <div class="text">
                  <span class="owt1">{{ item1.name }}</span>
                </div>
              </div>
              <div class="item">
                <span class="owt1">ID</span>
                <div class="text">
                  <span class="owt1">{{ item1.cerNo }}</span>
                </div>
              </div>
            </li>
          </template>
          <li v-else>
            <div class="item" style="margin-top: 0 !important;">
              <span>Order Number</span>
              <div class="text">
                <span class="owt1">{{ item.itemId }}</span>
              </div>
            </div>
          </li>
        </ul>
        <div class="state notUsed">
          <span v-if="item.ticketStatus == 0">To Be Ticketed</span>
          <span v-if="item.ticketStatus == 1">To Be Activated</span>
          <span v-if="item.ticketStatus == 2">Unused</span>
          <span v-if="item.ticketStatus == 3">Partially used</span>
          <span v-if="item.ticketStatus == 4">Used</span>
          <span v-if="item.ticketStatus == 5">Refunded</span>
        </div>
      </li>
    </ul>
    <div class="selected">
      <button @click="refundTicket">Ask for a Refund</button>
    </div>
    <selectpopup
      v-if="selectpopupStata"
      callbackpath="touristhmtplaceorderEn"
      title="Ask for a Refund"
      @onselectpopup="onselectpopup"
      content="Are you sure you want to have the ticket refunded?"
    />
  </div>
</template>

<script>
import { scatteredGetRefundTicket } from "@/service/refund/refundList.js";
export default {
  name: "hmtRefundListEn",
  data() {
    return {
      currentWhole: false,
      orderDetails: {},
      selectpopupStata: false,
      newOrderList: [],
      websorket: null
    };
  },
  created() {
    // 从订单直接缓存来的数据
    this.orderDetails = JSON.parse(window.sessionStorage.getItem("orderDetails"));
    this.orderDetails.itemList = this.orderDetails.itemList.filter(
      item => item.ticketStatus === "2"
    );
    this.controlSorket();
  },
  methods: {
    async onselectpopup(state) {
      if (state === "determine") {
        const { orderId } = this.$route.query;
        const data = await scatteredGetRefundTicket.call(this, {
          userId: JSON.parse(window.localStorage.getItem("userInfo")).userId,
          orderId,
          orderItemIdList: this.newOrderList
        });
        if (data.status == "0") {
          this.$loading.loadingStata = true;
          setTimeout(() => {
            if (this.$loading.loadingStata) {
              this.$loading.loadingStata = false;
              this.$toast({
                message: "Please wait while refund is in progress",
                duration: 3000
              });

              this.$router.push(`/touristorderdetailsEn?orderId=${orderId}`);
            }
          }, 5000);
        } else {
          if (data.errorCode != "4029") {
            this.$toast(data.errorMessage);
          }
        }
        this.$beyondHiding(false);
      }
      this.selectpopupStata = false;
    },
    updateWhole() {
      this.currentWhole = !this.currentWhole;
      this.orderDetails.itemList.forEach(item => (item.switchState = this.currentWhole));
    },
    clickSwitch(item) {
      item.switchState = !item.switchState;
      const state = this.orderDetails.itemList.every(item => item.switchState);
      state ? (this.currentWhole = true) : (this.currentWhole = false);
      this.$forceUpdate();
    },
    controlSorket() {
      const { orderId } = this.$route.query;
      this.websorket = new WebSocket(process.env.VUE_APP_WEBSORKET_BASE_URL + orderId);
      const hearCheck = {
        timeout: 10000,
        timeoutObj: {},
        reset: () => {
          clearInterval(this.timeoutObj);
        },
        start: () => {
          this.timeoutObj = setInterval(() => {
            this.websorket.send("nowDate" + Date());
          }, hearCheck.timeout);
        }
      };
      const createLink = () => {
        hearCheck.reset();
        hearCheck.start();
      };
      this.websorket.onopen = createLink;
      this.websorket.onmessage = event => {
        const { data } = event;
        if (data) {
          this.$toast("Refund Application Successsful");
          // socket断线
          hearCheck.reset();
          this.websorket.close();
          this.$loading.loadingStata = false;
          this.$router.push(`/touristorderdetailsEn?orderId=${orderId}`);
        }
      };
      this.websorket.onclose = createLink;
      this.websorket.onerror = createLink;
    },
    refundTicket() {
      const orderDetails = this.orderDetails;
      this.newOrderList = orderDetails.itemList.reduce((pre, cur) => {
        if (cur.switchState) pre.push(cur.itemId);
        return pre;
      }, []);
      if (!this.newOrderList.length) {
        return this.$toast("Please select tourists that need a refund");
      }
      this.selectpopupStata = true;
    }
  },
  watch: {
    selectpopupStata(newValue) {
      this.$beyondHiding(newValue);
    }
  }
};
</script>

<style scoped lang="less">
.box {
  min-height: 100vh;
  padding: 0 0 1.666667rem + 0.666667rem;
  .title {
    margin: 0.373333rem 0.346667rem 0;
    font-size: 0.24rem * 2;
    i {
      vertical-align: middle;
      margin: 0 0.2rem 0 0.3rem;
    }
    .header_title {
      font-size: 0.42rem;
    }
  }
  .title > i,
  ul > li > i {
    width: 0.213333rem * 2;
    height: 0.213333rem * 2;
  }
  .title > .checkMark,
  ul > li > .checkMark {
    background: #0078d7 url("~@/assets/image/common/common_icon.png") no-repeat ~"-4.91rem 0.11rem / 9.8rem 2.8rem";
  }
  .title > .fork,
  ul > li > .fork {
    border: 1px solid #a1a6ba;
  }

  & > ul {
    font-size: 0.373333rem;
    & > li {
      padding: 0 0.346667rem;
      margin: 0.373333rem 0.346667rem 0;
      background: #ffffff;
      border-radius: 0.16rem;
      display: flex;
      align-items: center;
      .content {
        padding-left: 0.346667rem;
        flex: 1;
        li {
          padding: 0.213333rem 0;
          .item {
            display: flex;
            &:last-child {
              margin-top: 0.32rem;
            }
            & > span {
              min-width: 4em;
              margin-right: 1em;
              color: rgba(58, 62, 92, 0.8);
            }
            .text {
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: space-between;
              span {
                max-width: 11em;
              }
              i {
                width: 0.173333rem * 2;
                height: 0.173333rem * 2;
              }
            }
          }
        }
      }
      .state {
        font-size: 0.32rem;
      }
      .notUsed {
        color: #3b6d9c;
      }
    }
  }
  .selected {
    position: fixed;
    bottom: 0.666667rem;
    display: flex;
    width: 100%;
    padding: 0 0.4rem;
    button {
      line-height: 1.333333rem;
      height: 1.25rem;
      background: #3b6d9c;
      border-radius: 0.16rem;
      width: 100%;
      font-size: 0.24rem * 2;
      font-weight: bold;
      color: #ffffff;
    }
  }
}
</style>
